export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>

export type Prettify<T> = {
  [K in keyof T]: T[K]
  // eslint-disable-next-line @typescript-eslint/ban-types
} & {}

export interface IShipperUserServiceResponse {
  email: string
  firstName: string
  lastName: string
  fullNameWithoutTitle?: string
  language: string
  timezone: string | null
  username: string | null
  shipperUuid: string
  id: string
  active: boolean
  auth0Id: string
  visibleCustomers: string[] | null
}

export enum OpsCustomerStatus {
  ACTIVE = 'active',
  LOST = 'lost',
  INACTIVE = 'inactive',
  LIVE = 'live',
}

export interface ICMDCustomerResponse {
  // there are more fields in the actual response, but we only need these for now
  // it's probably better to have here only what we need because data types and names change too often now
  // when the whole CMD system is stabilised, we can add the full response here
  id: string
  name: string
  status: OpsCustomerStatus
}
